import {
  ListItemButton,
  ListItemText,
  SxProps,
  Typography,
} from "@mui/material";

type Props = {
  primary: string;
  secondary: string;
  selected: boolean;
  sx?: SxProps;
  onClick: () => void;
  disabled?: boolean;
};

const ListItemComponent = ({
  primary,
  secondary,
  selected,
  sx,
  onClick,
  disabled,
}: Props) => {
  return (
    <ListItemButton
      sx={{
        ...sx,
        padding: "0px 10px",
        borderRadius: "8px",
        minHeight: "57.6px",
      }}
      selected={selected}
      onClick={onClick}
      disabled={disabled}
    >
      <ListItemText
        primary={<Typography fontWeight="600">{primary}</Typography>}
        secondary={
          <Typography color="textSecondary" fontSize="14px">
            {secondary}
          </Typography>
        }
      />
    </ListItemButton>
  );
};

export default ListItemComponent;
